import React, { useEffect, useState } from "react";
import { Form, Card, Button, InputNumber, Popconfirm, Space } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import useMessage from "antd/es/message/useMessage";

import { UserService } from "../../../../Services/Manage/UserService";
import { ExpenseServices } from "../../../../Services/Manage/ExpenseServices";
import GeneralExpenseAdd from "../../Expenses/GeneralExpenseAdd";
import BlukExpense from "./BlukExpense";

const CreateUB = ({ activeBillType, onClose, getAllExpense }) => {

    const [dataSource, setDataSource] = useState([]);
    const [count, setCount] = useState(1);
    const [vendorId, setVendorId] = useState(null);
    const [category, setCategory] = useState(null);
    const [poId, setPoId] = useState("");
    const [message, msgContx] = useMessage();

   

    useEffect(()=>{
        console.log(activeBillType);
        
    },[activeBillType])
    
    const handleNewAdd = () => {
        setDataSource([
            ...dataSource,
            { key: count, description: "", qty: 1, unitprice: 0, totalprice: 0 }
        ]);
        setCount(count + 1);
    };

    const handleAdd = (identifier) => {
        const newRow = { key: count, description: "", qty: 1, unitprice: 0, totalprice: 0 };
        const index = dataSource.findIndex((item) => item.id === identifier || item.key === identifier);

        let newData = [...dataSource];
        newData.splice(index + 1, 0, newRow);

        setDataSource(newData);
        setCount(count + 1);
    };

    const handleDelete = async (record) => {
        const newData = dataSource.filter((item) => item.key !== record.key);
        setDataSource(newData);
        message.success("Row deleted");
    };

    const handleChange = (identifier, field, value) => {
        const newData = dataSource.map((item) => {
            if (item.key === identifier || item.id === identifier) {
                const updatedItem = { ...item, [field]: value };
                updatedItem.totalprice = (updatedItem.qty || 0) * (updatedItem.unitprice || 0);
                return updatedItem;
            }
            return item;
        });
        setDataSource(newData);
    };

    const handleGeneralSave = async () => {
        try {
            const user = await UserService.getOmeUser();

            const formattedData = dataSource.map(({ key, ...rest }) => ({
                ...rest,
                added_by: user.uid,
                type: "bill",
                vendor_id: vendorId,
                category: category,
                bill_id: poId,
                bill_type: activeBillType
            }));

            const request = await ExpenseServices.createExpense(formattedData);

            if (request.status) {
                message.success(request.message);
                handleClose();
                getAllExpense();
            } else {
                message.error(request.message);
            }
        } catch (error) {
            console.error(error);
            message.error("Something went wrong");
        }
    };

    const handleClose = () => {
        onClose();
        setDataSource([]);
    };

    return (
        <div>
            {msgContx}

            <Card>
                {/* <Form layout="vertical"> */}

                    <BlukExpense
                        dataSource={dataSource}
                        setDataSource={setDataSource}
                        handleNewAdd={handleNewAdd}
                        handleAdd={handleAdd}
                        handleDelete={handleDelete}
                        handleChange={handleChange}
                        setVendorId={setVendorId}
                        setCategory={setCategory}
                        setPoId={setPoId}
                    />

                    <div style={{ marginTop: 50, display: "flex", justifyContent: "flex-end" }}>
                        <Space>
                            <Button size="large" type="primary" onClick={handleGeneralSave}>
                                Save
                            </Button>
                            <Button size="large" onClick={handleClose}>
                                Cancel
                            </Button>
                        </Space>
                    </div>

                {/* </Form> */}
            </Card>
        </div>
    );
};

export default CreateUB;
